(ns app.front.view.group.admin.fees.util.fee-template)


(def always-required-fields [:fee-template/titles
                             :bill/phase
                             :fee-template/type
                             :fee-template/unit-price-formula])

(defn required-fields
  "Returns a vector of required fields for fee template."
  [allow-penalty? penalty-rate interest-rate]
  (concat always-required-fields
          (when allow-penalty?
            (cond-> [:fee-template/allow-penalty?]
              (or interest-rate penalty-rate)       (conj :fee-template/penalty-rate
                                                          :fee-template/penalty-rate-type)
              interest-rate                         (conj :fee-template/interest-rate
                                                          :fee-template/interest-rate-type
                                                          :fee-template/interest-recurrence)
              (not (or penalty-rate interest-rate)) (conj :fee-template/interest-rate
                                                          :fee-template/penalty-rate)))))


(def required-for-integration [:fee-template/external-fee-code])


(def all-fields (concat (required-fields true :foo :foo)
                        required-for-integration
                        [:fee-template/minimum-total
                         :fee-template/group
                         :fee-template/quantity
                         :fee-template/quantity-formula
                         :fee-template/allow-including-in-property-tax?
                         :fee-template/unit
                         :fee-template/general-ledger-code
                         :fee-template/bond-payment?
                         :fee-template/refundable?
                         :fee-template/work-order-number?
                         :fee-template/date-rule
                         :fee-template/date-reference
                         :fee-template/apply-grace-period?
                         :fee-template/interest-occurrence-limit]))
